import React, { createContext, Dispatch, useReducer } from 'react';

import { IReconciliation } from '@/modules/workingDayReconciliation/types';

import { Actions, workingDayReconciliationReducer } from './reducer';

/******************************************************************************************
             NOTE: Add any global data for workingDayReconciliation module ex: advanced fillter
/*************************************************************************************** */

export type InitialStateType = {
  startDate: Date | null;
  endDate: Date | null;
  advancedFillter: null;
  currentSupplierSummary: IReconciliation.IGetWorkdaySummary | null;
  search?: string;
  workerId?: number;
};

const initialState: InitialStateType = {
  startDate: null,
  endDate: null,
  advancedFillter: null,
  currentSupplierSummary: null,
  search: undefined,
  workerId: undefined,
};

const WorkingDayReconciliationContext = createContext<{
  state: InitialStateType;
  dispatch: Dispatch<Actions>;
}>({
  state: initialState,
  dispatch: () => null,
});
//
const WorkingDayReconciliationProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [state, dispatch] = useReducer(
    workingDayReconciliationReducer,
    initialState
  );

  // action creators

  return (
    <WorkingDayReconciliationContext.Provider value={{ state, dispatch }}>
      {children}
    </WorkingDayReconciliationContext.Provider>
  );
};

export { WorkingDayReconciliationContext, WorkingDayReconciliationProvider };
